import React from 'react';
import ThankyouHead from './ThankyouHead';
import ThankyouTravellerInfo from './ThankyouTravellerInfo';
import RateCompStyled from './../rateCompStyled/rateCompStyled.jsx';
import { BottomBarBanner } from "@growth/app-banners/Banners/BottomBar";
import { isMobileView } from '../../Common/Utils';
import GoTribeBanner from "../../../components/GoTribe/ThankYou/Banner"
import { GoTribeThankyou } from '@growth/gotribe/goTribeThankyou'
import * as S from './ThankyouSucessStyle'
const ThankyouSuccess = props => {
    const { thankyouInfo, isLoggedIn, bookingStatus, popupContent, setPopupContent, feedbackStatus } = props;
    const {bookingList = []} = thankyouInfo;
    const {bookingid = '', finalBookingValue = '', bookingDate = '', arrDate = ''} = bookingList[0] || {}
    const mobileView = isMobileView();
    return (
        <>
            <ThankyouHead thankyouInfo={thankyouInfo} isLoggedIn={isLoggedIn} bookingStatus={bookingStatus}></ThankyouHead>
            <p>&nbsp;</p>
            <S.GoTribeThankYouPage>
            <GoTribeThankyou
                lob="bus"
                isMobile={mobileView}
                bookingPayload={{
                    pageType: 'THANKYOU',
                    bookingId: bookingid,
                    platform: `${mobileView? 'mweb' : 'desktop'}`,
                    group: 'BUS',
                    bookingCategory: 'DOMESTIC',
                    bookingDate: dateToTimestamp(bookingDate),
                    bookingAmount: finalBookingValue,
                    travelDate: dateToTimestamp(arrDate),
                }}
            />
            </S.GoTribeThankYouPage>
            <ThankyouTravellerInfo thankyouInfo={thankyouInfo} isLoggedIn={isLoggedIn} bookingStatus={bookingStatus} popupContent={popupContent} setPopupContent={setPopupContent}></ThankyouTravellerInfo>
            {/* {isLoggedIn ? <GoTribeBanner /> : <></>} */}
       
                {!feedbackStatus ? <RateCompStyled thankyouInfo={thankyouInfo}></RateCompStyled> : null}
            {mobileView ? <BottomBarBanner
                lobName="bus"
                page="thankyou"
                linkDetails={{
                    tagid: '714',
                    godata: { 'utm_campaign': 'mweb2app-bottombar-bus-typage' },
                    campaign: 'mweb2app-bottombar-bus-typage',
                    loginReq: true
                }}
                onClose={() => { }}
                onLoad={() => { }}
            /> : <></>}
        </>
    )
}

export default ThankyouSuccess;


function dateToTimestamp(dateStr) {
    // Create a new Date object from the date string
    const date = new Date(dateStr);
    
    // Get the timestamp (milliseconds since Unix epoch) and convert to seconds
    const timestamp = date.getTime() / 1000;
    
    return timestamp;
}

